import axios from "axios";
import {limitWallOfferPath} from "api/endpointPaths.mjs";
import {httpStatusOf} from "offers/ladder/LadderOfferApi";
import type {PricingCountry} from "pricing/planCatalogue";
import type {LimitWallOffer, LimitWallResolution} from "./limitWallOffer";

/** The limit-wall email link's resolve (kitecorp/transferify-api-service#2206). */
export class LimitWallOfferApi {
	/**
	 * A plain read: the api records the click on its own redirect, never here, so the page may repeat this
	 * (a reload, a language switch, a re-read after the till refused the token).
	 */
	static async resolve(token: string, country: PricingCountry | null): Promise<LimitWallResolution> {
		try {
			const {data} = await axios.get<LimitWallOffer>(limitWallOfferPath(token), {params: country ? {country} : {}});
			return {status: "offer", offer: data};
		} catch (error) {
			const status = httpStatusOf(error);
			// A limiter or edge failure says nothing about the link, so it is not read as an expiry.
			return status === 400 || status === 404 ? {status: "refused"} : {status: "unavailable"};
		}
	}
}
